import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/vip',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-index" */ '~/pages/r_code/vip/pages/index'
        )
    ),
  },
  {
    path: '/code/vip/rule',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-code-vip-rule" */ '~/pages/r_code/vip/pages/rule')
    ),
  },
  {
    path: '/code/vip/privilege',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-privilege" */ '~/pages/r_code/vip/pages/privilege'
        )
    ),
  },
  {
    path: '/code/vip/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-record" */ '~/pages/r_code/vip/pages/record'
        )
    ),
  },
  {
    path: '/code/vip/mission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-mission" */ '~/pages/r_code/vip/pages/mission'
        )
    ),
  },
  {
    path: '/code/vip/honor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-honor" */ '~/pages/r_code/vip/pages/honor'
        )
    ),
  },
  {
    path: '/code/vip/benefit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-benefit" */ '~/pages/r_code/vip/pages/benefit'
        )
    ),
  },
  {
    path: '/code/vip/activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-activity" */ '~/pages/r_code/vip/pages/activity'
        )
    ),
  },
  {
    path: '/code/vip/id',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-code-vip-id" */ '~/pages/r_code/vip/pages/id')
    ),
  },
  {
    path: '/code/vip/id/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-id-record" */ '~/pages/r_code/vip/pages/id/record'
        )
    ),
  },
  {
    path: '/code/vip/id/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-id-rule" */ '~/pages/r_code/vip/pages/id/rule'
        )
    ),
  },
  {
    path: '/code/vip/recall/levelRestore',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-recall-levelRestore" */ '~/pages/r_code/vip/pages/recall/levelRestore'
        )
    ),
  },
  {
    path: '/code/vip/recall/mission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-recall-mission" */ '~/pages/r_code/vip/pages/recall/mission'
        )
    ),
  },
  {
    path: '/code/vip/recall/score',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-recall-mission" */ '~/pages/r_code/vip/pages/recall/score'
        )
    ),
  },
  {
    path: '/code/vip/mib/buy', // 神秘人
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-mib-buy" */ '~/pages/r_code/vip/pages/mib/buy'
        )
    ),
  },
  {
    path: '/code/vip/mib/record', // 神秘人购买记录
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-mib-record" */ '~/pages/r_code/vip/pages/mib/record'
        )
    ),
  },
  {
    path: '/code/vip/interests', // 权益对比页面
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-interests" */ '~/pages/r_code/vip/pages/interests'
        )
    ),
  },
  {
    path: '/code/vip/bounsPlay', // 玩法加成
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-vip-bounsPlay" */ '~/pages/r_code/vip/pages/bounsPlay'
        )
    ),
  },
] as RouteConfig[]
